<template>
    <div class="program-detail-card">
        <p class="cards-title">production Techniques</p>
        <div class="my-3">
            <div v-for="technique in productionTechniques" :key="technique.label" class="px-3 py-2">
                <p class="subtitle">{{ technique.label }}</p>
                <p class="value">{{ technique.value }}</p>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import {defineProps, PropType} from 'vue';
interface productionTechniquesInterface {
    label: string, 
    value: string
}
defineProps({
    productionTechniques: Array as PropType<productionTechniquesInterface[]>
})
</script>
<style lang="scss" scoped>
.subtitle {
    font-weight: 500;
    color: $grey;
}
.value {
    font-weight: 300;
    font-size: 0.9rem;
}
    
</style>